query CountryAccess($id: ID!) {
  countryAccess(id: $id) {
    id
    title
    type
    countries
    isDefault
    createdAt
    updatedAt
  }
}
